import AuthWrap from "@/features/auth/components/AuthWrap";
import SignupForm from "@/features/auth/components/SignupForm";
import type { OrganisationSummary, UserMetadata } from "@/types/zod/auth";
import { createFileRoute } from "@tanstack/react-router";
import SignupTitle from "../../features/auth/components/SignupTitle";
import type { templateSettingsSchema } from "../../types/zod/quickstart-settings";

const Signup = () => {
	const search = Route.useSearch();

	return (
		<AuthWrap>
			<SignupTitle search={search} />
			<SignupForm search={search} />
		</AuthWrap>
	);
};

export const validateSignupSearch = (
	search: Record<string, unknown>,
): UserMetadata => {
	return {
		role: search?.role as "PATIENT",
		email: (search?.email as string) ?? undefined,
		organisation: (search?.organisation as OrganisationSummary) ?? undefined,
		quickstart: (search?.quickstart as TemplateSettingsSchemaT) ?? undefined,
	};
};

export const Route = createFileRoute("/_auth/signup")({
	component: Signup,
	validateSearch: validateSignupSearch,
});
